export enum GeometryType {
  Point = "Point",
  LineString = "LineString",
  Polygon = "Polygon",
  MultiPoint = "MultiPoint",
  MultiLineString = "MultiLineString",
  MultiPolygon = "MultiPolygon"
}

export type MapboxLayerType = "fill" | "line" | "circle";

export function getMapboxLayerType(geometryType: string): MapboxLayerType {
  if (geometryType === "Polygon" || geometryType === "MultiPolygon") {
    return "fill";
  }

  if (geometryType === "LineString" || geometryType === "MultiLineString") {
    return "line";
  }

  return "circle";
}

export function isLineGeometry(geometryType: string): boolean {
  return geometryType === "LineString" || geometryType === "MultiLineString";
}

export function isPolygonGeometry(geometryType: string): boolean {
  return geometryType === "Polygon" || geometryType === "MultiPolygon";
}

export function isPointGeometry(geometryType: string): boolean {
  return geometryType === "Point" || geometryType === "MultiPoint";
}
